import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listModules, getTeacherClasses } from "../../api/client";
import LiveQuizTab from "../../components/liveQuiz/LiveQuizTab";
import { useTranslation } from "../../hooks/useTranslation";
import { useLanguage } from "../../contexts/LanguageContext";

export default function LiveQuizPage() {
  const { locale } = useLanguage();
  const [modules, setModules] = useState([]);
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [teacherClasses, setTeacherClasses] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    listModules()
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        setModules(arr);
        if (arr.length > 0) setSelectedModuleId(arr[0].id);
      })
      .catch(console.error);

    getTeacherClasses()
      .then((data) => setTeacherClasses(Array.isArray(data) ? data : []))
      .catch(() => setTeacherClasses([]));
  }, []);

  return (
    <main style={{ backgroundColor: "var(--bg-secondary)", minHeight: "100vh" }}>
      <div className="container-fluid py-4 px-4">

        <div className="mb-4">
          <h1 className="mb-1">{t.nav.liveQuiz}</h1>
          <p className="text-muted">{t.liveQuiz.pageSubtitle}</p>
        </div>

        {modules.length > 1 && (
          <div className="mb-3">
            <label className="form-label fw-semibold">{t.liveQuiz.selectModule}</label>
            <select
              className="form-select"
              style={{ maxWidth: "100%", width: "fit-content", minWidth: "200px" }}
              value={selectedModuleId || ""}
              onChange={(e) => setSelectedModuleId(e.target.value)}
            >
              {modules.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.title || `Modul ${m.id}`}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="card border-0 shadow-sm">
          <div className="card-body p-0">
            {selectedModuleId ? (
              <LiveQuizTab
                moduleId={selectedModuleId}
                classes={teacherClasses}
                lang={locale}
              />
            ) : (
              <div className="text-center py-5 text-muted">
                <p>{t.liveQuiz.noModule}</p>
                <button className="btn btn-outline-primary" onClick={() => navigate("/teacher/content")}>
                  {t.liveQuiz.createModule}
                </button>
              </div>
            )}
          </div>
        </div>

      </div>
    </main>
  );
}
